<template>
    <div class="exception-record-container">
        <div class="page-header">
            <h2>异常记录</h2>
            <el-button type="primary" icon="el-icon-download" @click="handleExport">导出记录</el-button>
        </div>

        <!-- 搜索栏 -->
        <el-form :inline="true" :model="searchForm" class="search-form" @submit.native.prevent>
            <el-form-item>
                <el-input
                    v-model.trim="searchForm.personKeyword"
                    placeholder="人员姓名/工号"
                    clearable
                    style="width: 200px"
                    @keyup.enter.native.prevent="handleSearch"
                ></el-input>
            </el-form-item>
            <el-form-item label="全部异常类型">
                <el-select v-model="searchForm.exceptionType" clearable style="width: 160px">
                    <el-option value="代替打卡" label="代替打卡"></el-option>
                    <el-option value="OCR信息不一致" label="OCR信息不一致"></el-option>
                    <el-option value="人脸比对不通过" label="人脸比对不通过"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="全部处理状态">
                <el-select v-model="searchForm.handleStatus" clearable style="width: 160px">
                    <el-option value="未处理" label="未处理"></el-option>
                    <el-option value="处理中" label="处理中"></el-option>
                    <el-option value="已处理" label="已处理"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="年/月/日">
                <el-date-picker
                    v-model="searchForm.dateRange"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd"
                    style="width: 240px"
                ></el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
            </el-form-item>
        </el-form>

        <!-- 数据表格 -->
        <el-table
            :data="tableData"
            v-loading="tableLoading"
            :header-cell-style="{
                'text-align': 'center',
                'font-size': '16px',
                'font-weight': '600',
                color: '#2d2d2d',
                'background-color': '#f5f7fa'
            }"
            :cell-style="{ 'text-align': 'left', 'font-size': '14px', padding: '12px' }"
            :row-style="tableRowStyle"
        >
            <el-table-column label="记录ID" width="100" align="center">
                <template slot-scope="scope">
                    {{ scope.row.recordId }}
                </template>
            </el-table-column>
            <el-table-column label="异常人员" width="160">
                <template slot-scope="scope"> {{ scope.row.personName }}<br />({{ scope.row.empNo }}) </template>
            </el-table-column>
            <el-table-column label="异常时间" width="160" align="center">
                <template slot-scope="scope">
                    {{ scope.row.exceptionTime }}
                </template>
            </el-table-column>
            <el-table-column label="异常地点" width="100" align="center">
                <template slot-scope="scope">
                    {{ scope.row.location }}
                </template>
            </el-table-column>
            <el-table-column label="异常类型" width="140" align="center">
                <template slot-scope="scope">
                    {{ scope.row.exceptionType }}
                </template>
            </el-table-column>
            <el-table-column label="异常原因" min-width="260">
                <template slot-scope="scope">
                    {{ scope.row.reason }}
                </template>
            </el-table-column>
            <el-table-column label="证据" width="80" align="center">
                <template slot-scope="scope">
                    <el-image
                        v-if="scope.row.evidenceUrl"
                        :src="scope.row.evidenceUrl"
                        style="width: 40px; height: 40px; border-radius: 4px"
                        fit="cover"
                    ></el-image>
                    <span v-else>无</span>
                </template>
            </el-table-column>
            <el-table-column label="处理状态" width="100" align="center">
                <template slot-scope="scope">
                    <span :class="['status-dot', scope.row.handleStatus]"></span>
                    {{ scope.row.handleStatus }}
                </template>
            </el-table-column>
            <el-table-column label="操作" width="120" align="center">
                <template slot-scope="scope">
                    <el-button
                        type="primary"
                        size="mini"
                        plain
                        icon="el-icon-edit"
                        @click="handleProcess(scope.row)"
                        style="margin-bottom: 5px"
                        >处理</el-button
                    >
                    <el-button type="info" size="mini" plain icon="el-icon-view" @click="handleDetail(scope.row)">详情</el-button>
                </template>
            </el-table-column>
        </el-table>

        <!-- 分页 -->
        <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            layout="prev, pager, next"
            :total="totalDataNumber"
            :page-size="pageSize"
            align="center"
            class="pagination"
        ></el-pagination>

        <!-- 处理弹窗 -->
        <el-dialog title="处理异常记录" :visible.sync="processDialogVisible" :close-on-click-modal="false">
            <el-form ref="processForm" :model="processForm" label-width="100px">
                <el-form-item label="处理意见">
                    <el-input v-model.trim="processForm.remark" type="textarea" :rows="3" placeholder="请输入处理意见"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="processDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitProcessForm" :loading="processLoading">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { baseURL } from '@/utils/request.js';

export default {
    name: 'ExceptionRecord',
    data() {
        return {
            searchForm: {
                personKeyword: '',
                exceptionType: '',
                handleStatus: '',
                dateRange: []
            },
            tableData: [],
            tableLoading: false,
            currentPage: 1,
            pageNo: 1,
            pageSize: 10,
            totalDataNumber: 0,
            processDialogVisible: false,
            processLoading: false,
            processForm: {
                id: '',
                remark: ''
            }
        };
    },
    methods: {
        tableRowStyle({ row, rowIndex }) {
            if (rowIndex % 2 === 0) {
                return 'background-color: #ffffff';
            } else {
                return 'background-color: #fafafa';
            }
        },
        handleSearch() {
            this.pageNo = 1;
            this.queryExceptionList();
        },
        handleReset() {
            this.searchForm = {
                personKeyword: '',
                exceptionType: '',
                handleStatus: '',
                dateRange: []
            };
            this.pageNo = 1;
            this.queryExceptionList();
        },
        queryExceptionList() {
            const params = {
                pageNo: String(this.pageNo),
                pageSize: String(this.pageSize)
            };
            if (this.searchForm.personKeyword) params.personKeyword = this.searchForm.personKeyword;
            if (this.searchForm.exceptionType) params.exceptionType = this.searchForm.exceptionType;
            if (this.searchForm.handleStatus) params.handleStatus = this.searchForm.handleStatus;
            if (this.searchForm.dateRange && this.searchForm.dateRange.length > 0) {
                params.startDate = this.searchForm.dateRange[0];
                params.endDate = this.searchForm.dateRange[1];
            }

            this.tableLoading = true;
            this.$postJson('dmc/Exception/queryExceptionList', params)
                .then((res) => {
                    if (res.code === 200) {
                        this.pageSize = res.result.pageSize;
                        this.currentPage = res.result.pageNum;
                        this.totalDataNumber = res.result.total * 1;
                        this.tableData = res.result.list || [];
                    } else {
                        this.tableData = [];
                        this.totalDataNumber = 0;
                    }
                    setTimeout(() => {
                        this.tableLoading = false;
                    }, 500);
                })
                .catch(() => {
                    this.tableLoading = false;
                });
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.queryExceptionList();
        },
        handleCurrentChange(val) {
            this.pageNo = val;
            this.queryExceptionList();
        },
        handleExport() {
            window.location.href = baseURL + 'dmc/Exception/exportExceptionList';
        },
        handleProcess(row) {
            this.processForm = {
                id: row.id,
                remark: ''
            };
            this.processDialogVisible = true;
        },
        submitProcessForm() {
            this.processLoading = true;
            this.$postJson('dmc/Exception/handleException', this.processForm)
                .then((res) => {
                    if (res.code === 200) {
                        this.$message.success('处理成功');
                        this.processDialogVisible = false;
                        this.queryExceptionList();
                    } else {
                        this.$message.error(res.message || '处理失败');
                    }
                    this.processLoading = false;
                })
                .catch(() => {
                    this.processLoading = false;
                });
        },
        handleDetail(row) {
            this.$message.info(`查看异常详情：${row.recordId}`);
            // 可跳转到详情页或打开详情弹窗
        }
    },
    mounted() {
        this.queryExceptionList();
    }
};
</script>

<style lang="scss" scoped>
.exception-record-container {
    padding: 20px;
    background: #fff;
    border-radius: 4px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

    .page-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 20px;

        h2 {
            margin: 0;
            font-size: 24px;
            color: #333;
        }
    }

    .search-form {
        padding: 15px;
        background: #f9f9f9;
        border-radius: 4px;
        margin-bottom: 20px;
    }

    .status-dot {
        display: inline-block;
        width: 10px;
        height: 10px;
        border-radius: 50%;
        margin-right: 6px;

        &.未处理 {
            background-color: #f53f3f;
        }
        &.处理中 {
            background-color: #ff9900;
        }
        &.已处理 {
            background-color: #00b42a;
        }
    }

    .pagination {
        margin-top: 20px;
        text-align: center;
    }
}
</style>
